/* unplugin-vue-components disabled */import { render } from "./KilaKilaFooter.vue?vue&type=template&id=75dc0a24&scoped=true"
import script from "./KilaKilaFooter.vue?vue&type=script&lang=js"
export * from "./KilaKilaFooter.vue?vue&type=script&lang=js"

import "./KilaKilaFooter.vue?vue&type=style&index=0&id=75dc0a24&scoped=true&lang=css"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dc0a24"]])

export default __exports__